<template>
<div id="loading-bg">
  <div class="loading">
    <div class="effect-1 effects"></div>
    <div class="effect-2 effects"></div>
    <div class="effect-3 effects"></div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BRANCHES_FETCH } from '@/store/action.types'
export default {
  data() {
    return {}
  },
  async created() {
    // this.$router.push('/profile')
    if (this.$acl.get.includes('company')) {
      // await this.$store.dispatch(BRANCHES_FETCH)

      // if (this.companyBranches.length !== 0) {

      await this.$store.dispatch(BRANCHES_FETCH)
      this.$router.push({ name: 'branchDetailEmployee', params: { id: this.companyBranches[0].id }})
    } else if (this.$acl.get.includes('employee')) {
      this.$router.push({ name: 'employeeProfile' })
    } else {
      this.$router.push({ name: 'pageNotAuthorized' })
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'companyBranches'
    ])
  }
}
</script>

<style lang="css" scoped>
</style>
